import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

function ActivateAccountView({ message }) {
    const { t } = useTranslation();

    return (
        <main className="container">
            <div className="card max-w-lg mx-auto mt-8">
                <div className="card-body text-center">
                    <h1 className="text-2xl font-bold mb-4">
                        {t('activate.title')}
                    </h1>
                    <p className="text-base" role="status" aria-live="polite">
                        {message}
                    </p>
                </div>
            </div>
        </main>
    );
}

ActivateAccountView.propTypes = {
    message: PropTypes.string.isRequired,
};

export default ActivateAccountView;
